
<template>
  <div>
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
      label-position="right"
    >
      <el-row :gutter="20">
        <!-- 类型 -->

        <el-col :span="12">
          <el-form-item
            prop="leiXing"
            label="类型"
          >
            <el-input
              v-model="entityData.leiXing"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 级别 -->

        <el-col :span="12">
          <el-form-item
            prop="jiBieDictKey"
            label="级别"
          >
            <Combox
              v-model="entityData.jiBieDictKey"
              type-id="D35"
              :option-data="getComboxData('D35')"
              :add-client="true"
            />
          </el-form-item>
        </el-col>

        <!-- 学会 -->

        <el-col :span="12">
          <el-form-item
            prop="xueHui"
            label="学会"
          >
            <el-input
              v-model="entityData.xueHui"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 专委会 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuanWeiHui"
            label="专委会"
          >
            <el-input
              v-model="entityData.zhuanWeiHui"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 理事长 -->

        <el-col :span="12">
          <el-form-item
            prop="liShiZhang"
            label="理事长"
          >
            <el-input
              v-model="entityData.liShiZhang"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 常务理事 -->

        <el-col :span="12">
          <el-form-item
            prop="changWuLiShi"
            label="常务理事"
          >
            <el-input
              v-model="entityData.changWuLiShi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 理事 -->

        <el-col :span="12">
          <el-form-item
            prop="liShi"
            label="理事"
          >
            <el-input
              v-model="entityData.liShi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 主任委员 -->

        <el-col :span="12">
          <el-form-item
            prop="zhuRenWeiYuan"
            label="主任委员"
          >
            <el-input
              v-model="entityData.zhuRenWeiYuan"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 名誉主任委员 -->

        <el-col :span="12">
          <el-form-item
            prop="mingYuZhuRenWeiYuan"
            label="名誉主任委员"
          >
            <el-input
              v-model="entityData.mingYuZhuRenWeiYuan"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 常务副主任委员 -->

        <el-col :span="12">
          <el-form-item
            prop="changWuFuZhuRenWeiYuan"
            label="常务副主任委员"
          >
            <el-input
              v-model="entityData.changWuFuZhuRenWeiYuan"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 副主任委员 -->

        <el-col :span="12">
          <el-form-item
            prop="fuZhuRenWeiYuan"
            label="副主任委员"
          >
            <el-input
              v-model="entityData.fuZhuRenWeiYuan"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 委员 -->

        <el-col :span="12">
          <el-form-item
            prop="weiYuan"
            label="委员"
          >
            <el-input
              v-model="entityData.weiYuan"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 任职 -->

        <el-col :span="12">
          <el-form-item
            prop="renZhi"
            label="任职"
          >
            <el-input
              v-model="entityData.renZhi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 届次 -->

        <el-col :span="12">
          <el-form-item
            prop="jieCi"
            label="届次"
          >
            <el-input
              v-model="entityData.jieCi"
              clearable
            />
          </el-form-item>
        </el-col>

        <!-- 开始日期 -->
        <el-col :span="12">
          <el-form-item
            prop="kaiShiRiQi"
            label="开始日期"
          >
            <el-date-picker
              v-model="entityData.kaiShiRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 到期日期 -->
        <el-col :span="12">
          <el-form-item
            prop="daoQiRiQi"
            label="到期日期"
          >
            <el-date-picker
              v-model="entityData.daoQiRiQi"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>

        <!-- 助理 -->
        <el-col :span="12">
          <el-form-item
            prop="assitantList"
            label="助理"
          >
            <AssistEditForm
              v-model="entityData.assitantList"
              module-code="jx02"
            />
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="dialog-footer">
      <el-button
        v-if="ketiInfo.isFuzeren || ketiInfo.isZuli"
        type="primary"
        @click="handleSave()"
      >
        保  存
      </el-button>
    </div>
  </div>
</template>
<script>
import pathReq from '@/api/pathlist'
import Combox from '@/views/managesystem/gz/com/Combox'
import AssistEditForm from '@/views/managesystem/gz/com/AssistEditForm.vue'
export default {
  components: {
    Combox, AssistEditForm
  },
  props: {
    // postId: { type: Number, default: null }
  },
  data() {
    return {
      entityId: null,
      entityData: {},
      allComboxData: [],
      rules: {
        renZhi: [
          { required: true, message: '请输入任职', trigger: 'change,blur' }
        ]
      },
      selectedValue: [],
      ketiInfo: {}
    }
  },
  computed: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D35').then(res => {
      this.allComboxData = res.data.result
    })
  },
  activated() {
    this.init()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    /**
     * 初始化数据
     */
    init() {
      this.entityId = this.$route.params.id
      if (!this.entityId) {
        this.$router.go(-1)
        return
      }
      const path = '/api/services/app/xs01/GetEditxs01?Id=' + this.entityId
      pathReq.getNoParams(path).then(res => {
        this.entityData = res.data.result.entityData
      }).then(_ => {
        pathReq.getKetiInfo('xs01', this.entityData.id).then(r => {
          this.ketiInfo = r.data.result
        })
      })
    },
    /**
     * 打开数据字典弹出框
     */
    handleAddComboxData(dictTypeId, dictTypeName) {
      this.$bus.emit('comboxData', dictTypeId, dictTypeName)
    },
    /**
     * 新增或者修改身份信息数据
     */
    handleSave() {
      this.$refs['entityData'].validate(valid => {
        if (valid) {
          const that = this
          const path = '/api/services/app/xs01/CreateOrUpdatexs01'

          pathReq
            .postForm(path, { entityData: that.entityData })
            .then(res => {
              that.$message.success('保存成功')
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.el-dialog__body {
  padding-top: 10px !important;
}

.dialog-footer {
  text-align: right;
}

.el-select {
  margin-right: 8px;
  width: 84% !important;
}
</style>
